import Endpoint from "@/utils/endPoint";

const commentsEndpoint = new Endpoint("/comments/teachers/");
const commentEndpoint = new Endpoint("/comments/teachers/{commentId}");

class AlbumService {
    async createCommentService(params) {
        const result = await commentsEndpoint.post(params);
        return result;
    }
    async delCommentService(params) {
        const result = await commentEndpoint.del(null, params);
        return result;
    }
}

export default new AlbumService();
